import { Button } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';

import { TurboTag } from '../turbo-tag';
import { StoreStatusDrop } from 'components/store-status/store-status-drop';

import { useHighDemandBtn } from './hooks';

import makeClasses from './HighDemandBtn.style';

import type { HTMLAttributes } from 'react';
import type { SaturationStateProp } from '../../shared/models';

export function HighDemandBtn(props: HighDemandBtnProps) {
  const {
    isSingleStore = true,
    everyIsActive,
    hasActiveTurboStores,
    ...extraProps
  } = props;

  const { text, variant } = useHighDemandBtn({
    isSingleStore,
    pureVariant: props.variant,
  });

  const _classes = makeClasses({ variant });

  return (
    <div className={_classes.container} {...extraProps}>
      <StoreStatusDrop />
      {hasActiveTurboStores ? (
        <TurboTag variant='header' />
      ) : (
        variant !== 'deactivated' &&
        !everyIsActive && (
          <Button
            size='large'
            type='button'
            variant='contained'
            classes={{ contained: _classes.btn }}
          >
            {text.status} {text.demandTimer}
          </Button>
        )
      )}
      <ChevronRight
        fontSize='small'
        viewBox='8 1 8 20'
        className={_classes.arrowIcon}
      />
    </div>
  );
}

interface HighDemandBtnProps
  extends SaturationStateProp,
    HTMLAttributes<HTMLDivElement> {
  isSingleStore?: boolean;
  everyIsActive: boolean;
  hasActiveTurboStores: boolean;
}
